// extracted by mini-css-extract-plugin
module.exports = {"cpDetailAddressClass":"DetailsPage_cpDetailAddressClass__3VDN0","cpDetailsBuildingIcon":"DetailsPage_cpDetailsBuildingIcon__3TjFQ"};